import { render, staticRenderFns } from "./CopyDictionary.vue?vue&type=template&id=3a346e2f&scoped=true&"
import script from "./CopyDictionary.vue?vue&type=script&lang=js&"
export * from "./CopyDictionary.vue?vue&type=script&lang=js&"
import style0 from "./CopyDictionary.vue?vue&type=style&index=0&id=3a346e2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a346e2f",
  null
  
)

export default component.exports